import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../../utils";
import { getUserInitials, getUserFullName, getUserAvatarUrl } from "../../../utils/user-utils";
import { Avatar, AvatarFallback, AvatarImage } from "../../base/avatar/avatar";
import { Badge } from "../../base/badge/badge";
import { Item, ItemContent, ItemDescription, ItemMedia, ItemTitle } from "../../base/item/item";
import { DELETED_ENTITY_CLASS, isAssigneeDeleted } from "../../../utils/deleted-entity-utils";
import { UserName } from "./user-name";
export const UserCard = /*#__PURE__*/ React.forwardRef(({ user, variant = "name-only", itemVariant = "default", size = "default", className, showLifecycleSuffix = true, titleSlot, descriptionSlot, rightSlot }, ref)=>{
    const initials = getUserInitials(user.firstName, user.lastName);
    const fullName = getUserFullName(user.firstName, user.lastName);
    const isDeleted = isAssigneeDeleted(user);
    let secondaryText = null;
    if (variant === "with-role") {
        secondaryText = user.role?.name;
    } else if (variant === "with-email") {
        secondaryText = user.email;
    }
    const showDescription = descriptionSlot ?? secondaryText;
    return /*#__PURE__*/ _jsxs(Item, {
        ref: ref,
        variant: itemVariant,
        size: size,
        className: cn(className, isDeleted && DELETED_ENTITY_CLASS),
        children: [
            /*#__PURE__*/ _jsx(ItemMedia, {
                variant: "image",
                children: /*#__PURE__*/ _jsxs(Avatar, {
                    children: [
                        /*#__PURE__*/ _jsx(AvatarImage, {
                            src: getUserAvatarUrl(user, "thumbnail"),
                            alt: fullName
                        }),
                        /*#__PURE__*/ _jsx(AvatarFallback, {
                            className: "bg-yellow-avatar text-white",
                            children: initials
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(ItemContent, {
                children: [
                    /*#__PURE__*/ _jsx(ItemTitle, {
                        children: titleSlot ?? (showLifecycleSuffix ? /*#__PURE__*/ _jsx(UserName, {
                            name: fullName,
                            user: user
                        }) : fullName)
                    }),
                    showDescription && /*#__PURE__*/ _jsx(ItemDescription, {
                        children: showDescription
                    })
                ]
            }),
            rightSlot ? rightSlot : user.departmentAbbreviation && /*#__PURE__*/ _jsx(Badge, {
                variant: "outline",
                className: "self-center",
                children: user.departmentAbbreviation
            })
        ]
    });
});
UserCard.displayName = "UserCard";
export function toUserCardProps(user) {
    return {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        // The card's `role` line shows the user's Stelle (mainRole OrgFunction).
        role: user.mainRole,
        avatar: user.avatar,
        departmentAbbreviation: user.department?.abbreviation,
        // Tombstone marker — lookup-sourced users gray out when soft-deleted
        deletedAt: user.deletedAt,
        // Lifecycle status — suspended users self-suffix "(suspended)"
        status: user.status
    };
}

//# sourceMappingURL=user-card.js.map